<form [formGroup]="inputFieldForm">
  <div #inputFieldContent class="current-input-field-content" [ngStyle]="contentStyle">
    <div class="d-flex w-100">
      <div>
        <span class="currency-symbol" [ngStyle]="labelStyle">
          {{ currencySymbol }}
        </span>
      </div>
      <div class="position-relative w-100">
        <span class="currency-input-field-widget-input visibility-hidden mr-1">{{
          String(inputFieldForm?.get(this.inputFieldKey)?.value || '0') | customCurrency : currencyCode || ''
        }}</span>
        <input
          inputPrice
          class="currency-input-field-widget-input position-absolute-fill input-style-ios-user-agent-style-override webkit-tap-highlight-color-transparent"
          [name]="inputFieldKey"
          [formControlName]="inputFieldKey"
          [value]="inputValue"
          (keyup)="onChange()"
          [placeholder]="inputPlaceholder"
          [attr.inputmode]="inputMode"
          [ngStyle]="inputStyle"
          [attr.maxlength]="maxLength"
        />
      </div>
    </div>
  </div>
</form>
